import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  doc,
  setDoc,
  getDocs
} from "firebase/firestore";
import Navbar from "../components/AgentNavbar";
import { FaUserPlus, FaKey, FaPhone, FaEnvelope, FaDollarSign } from "react-icons/fa";

export default function AddClient() {
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [initialBalance, setInitialBalance] = useState("");
  const [generatedUsername, setGeneratedUsername] = useState("");
  const [generatedPassword, setGeneratedPassword] = useState("");
  const [statusMsg, setStatusMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hasCreatedClient, setHasCreatedClient] = useState(false);

  const [agentUsername, setAgentUsername] = useState("");

  useEffect(() => {
    const currentUser = localStorage.getItem("currentUser");
    if (currentUser) {
      setAgentUsername(currentUser);
    }
  }, []);

  const generateUsername = async (name) => {
    const base = name.replace(/\s+/g, "").toLowerCase();
    const usersSnapshot = await getDocs(collection(db, "users"));
    const existingUsernames = usersSnapshot.docs.map((doc) => doc.id);

    let newUsername = "";
    let attempts = 0;

    do {
      const suffix = Math.floor(100 + Math.random() * 900); // random 3 digits
      newUsername = `${base}${suffix}`;
      attempts++;
    } while (existingUsernames.includes(newUsername) && attempts < 100);

    return newUsername;
  };

  const generatePassword = () => {
    const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from({ length: 6 }, () =>
      charset[Math.floor(Math.random() * charset.length)]
    ).join("");
  };

  const handleAddClient = async () => {
    if (!fullName.trim()) return alert("Full name is required.");
    if (!initialBalance) return alert("Initial balance is required.");

    setIsLoading(true);
    setStatusMsg("");

    try {
      const username = await generateUsername(fullName);
      const password = generatePassword();

      await setDoc(doc(db, "users", username), {
  fullName,
  phone,
  email,
  startingBalance: parseFloat(initialBalance),
  username,
  password,
  role: "client",
  createdBy: agentUsername,
  joined: new Date().toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }),
});

      setGeneratedUsername(username);
      setGeneratedPassword(password);
      setHasCreatedClient(true);
      setStatusMsg(`Client ${username} created successfully!`);
    } catch (err) {
      console.error(err);
      setStatusMsg("An error occurred while creating the client.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: "700px", margin: "2rem auto", padding: "2rem", background: "#fff", borderRadius: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
      <Navbar />
      <h2 style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <FaUserPlus /> Add New Client <span style={{ fontSize: "0.8rem", color: "gray" }}></span>
      </h2>
      <p>Enter the new client’s information. The system will check if the client already exists before proceeding.</p>

      <div style={{ marginTop: "1.5rem" }}>
        <label>Client Full Name</label>
        <input
          type="text"
          placeholder="Enter client's full name"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          style={inputStyle}
        />

        <label>Phone Number (Optional)</label>
        <input
          type="text"
          placeholder="Enter phone number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          style={inputStyle}
        />

        <label>Email Address (Optional)</label>
        <input
          type="email"
          placeholder="Enter email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
        />

        <label>Initial Balance</label>
        <input
          type="number"
          placeholder="e.g. 100.00"
          value={initialBalance}
          onChange={(e) => setInitialBalance(e.target.value)}
          style={inputStyle}
        />
        <small>Set the starting balance for the client (defaults to $0.00). Use '.' or ',' for decimals. Current Value: ${initialBalance || "0.00"}</small>
      </div>

      <div style={cardBoxStyle}>
        <h4><FaKey /> Client Password & Card</h4>
        <button disabled style={disabledBtnStyle}>Generate Password & Card #</button>
        <p style={{ fontSize: "0.9rem", color: "gray" }}>
          Generate credentials only if the system indicates that the client is new after you click "Add Client".
        </p>
      </div>

      <button
        onClick={handleAddClient}
        disabled={isLoading}
        style={addBtnStyle}
      >
        {isLoading ? "Creating..." : "Add Client"}
      </button>

      {statusMsg && <p style={{ marginTop: "1rem" }}>{statusMsg}</p>}

      {hasCreatedClient && (
        <div style={cardBoxStyle}>
          <h4><FaKey /> Client Credentials</h4>
          <p><strong>Username:</strong> {generatedUsername}</p>
          <p><strong>Password:</strong> {generatedPassword}</p>
        </div>
      )}
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "0.6rem",
  margin: "0.5rem 0 1rem 0",
  border: "1px solid #ccc",
  borderRadius: "6px"
};

const cardBoxStyle = {
  marginTop: "2rem",
  padding: "1rem",
  background: "#f9fafb",
  borderRadius: "6px",
  border: "1px solid #e5e7eb"
};

const addBtnStyle = {
  backgroundColor: "#1e40af",
  color: "white",
  padding: "0.7rem 1.4rem",
  borderRadius: "4px",
  border: "none",
  cursor: "pointer",
  marginTop: "1.5rem"
};

const disabledBtnStyle = {
  backgroundColor: "#e5e7eb",
  color: "#6b7280",
  padding: "0.5rem 1rem",
  borderRadius: "4px",
  border: "none",
  cursor: "not-allowed",
  marginTop: "0.5rem"
};
